// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__IIYmA","list":"PatternAutocomplete_list__2_nn8"};